import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RechnerPage } from './rechner.page';
import { CustomCurrencyPipe } from '../services/pipes/euro';
import { FormsModule } from '@angular/forms';

const routes: Routes = [
  {
    path: '',
    component: RechnerPage,
  },
];

@NgModule({
  declarations: [CustomCurrencyPipe],
  imports: [RouterModule.forChild(routes), FormsModule],
  exports: [RouterModule, CustomCurrencyPipe],
})
export class RechnerPageRoutingModule {}
